module.exports = __webpack_public_path__ + "img/flavor4.fc892f06.svg";